import * as React from 'react';

import { ItemDescription } from '~src/app/spaces/Header/HeaderItemDescription';
import { TagsMetadata } from '~src/app/spaces/Header/TagsMetadata';
import { sanitize } from '~src/commonInfra/utils/Sanitize';
import { NewWorkbookEntityAction } from '~src/workbook/entityActions/NewWorkbookEntityAction';

import { SiteUrlsProps } from '../../app/selectors/SiteUrlsSelectors';
import { EditPublishedConnectionEntityAction } from '../../app/spaces/ActionsMenu/EntityActions/EditPublishedConnectionEntityAction';
import { ModifiedDateMetadata, OwnerMetadata } from '../../app/spaces/Header/HeaderMetadataRow';
import { ActionsMenuIcon, FavoriteToggleWithCountsIcon } from '../../app/spaces/Header/HeaderNameRowIcons';
import { ConnectedSpaceHeader } from '../../app/spaces/Header/SpaceHeader';
import { ISpaceItemDetailInfo } from '../../ts/models/ISpaceItemDetailInfo';
import { IPublishedConnectionActions } from '../../ts/ServerApi/types/IPublishedConnectionActions';

export interface PublishedConnectionSpaceHeaderProps extends SiteUrlsProps {
  readonly itemInfo: ISpaceItemDetailInfo<'publishedConnection'>;
  readonly availableActions: IPublishedConnectionActions;
  readonly openDetail: () => void;
  readonly addToFavorites: () => void;
  readonly removeFromFavorites: () => void;
}

export function PublishedConnectionSpaceHeader(props: PublishedConnectionSpaceHeaderProps): JSX.Element {
  const tagUrl = React.useCallback((tag: string) => props.urls.publishedConnectionsWithTagUrl(tag), [props.urls]);

  return (
    <ConnectedSpaceHeader
      item={props.itemInfo}
      // TODO: ntomsic TFSID-1265515 remove manual key once action has been added
      availableActions={{...props.availableActions, launchWebAuthoring: true}}
      nameRowIcons={
        <React.Fragment>
          {FavoriteToggleWithCountsIcon({
            item: props.itemInfo,
            addToFavorites: props.addToFavorites,
            removeFromFavorites: props.removeFromFavorites,
          })}
          {ActionsMenuIcon(props.itemInfo)}
        </React.Fragment>
      }
      // TODO: ntomsic TFSID-1259732 add ExtractMetadata once extract info has been added
      metadataRow={
        <React.Fragment>
          {OwnerMetadata(props.itemInfo.owner, props.urls)}
          {ModifiedDateMetadata(props.itemInfo.updatedAt)}
        </React.Fragment>
      }
      spotlightActions={[EditPublishedConnectionEntityAction, NewWorkbookEntityAction]}
      // TODO: ntomsic TFSID-1266691 description doesn't really work until this backend task is done
      descriptionElement={ItemDescription(props.itemInfo, props.openDetail, sanitize)}
      bottomElement={TagsMetadata({ itemInfo: props.itemInfo, tagUrl })}
    />
  );
}
